import React from "react";
import ControlFeedback from "./ControlFeedback";
import { FileUploadControlProps } from "./Types";

const FileUploadControl: React.FC<FileUploadControlProps> = ({ name, value, multiple, disabled, width, validationResults, onChange, onBlur }) => {

    function onControlChange(val: any) {
        if (multiple === true) {
            let files: File[] = []
            for (var i = 0; i < val.target.files.length; i++)
                files.push(val.target.files[i]);

            onChange(files);
        }
        else
            onChange(val.target.files[0]);
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    let className = "";
    if (validationResults && validationResults.length > 0)
        className = "is-invalid";

    if (width === undefined)
        width = 150;

    return (
        <div style={{ width: width }}>
            <input className={className} type='file' disabled={disabled} onChange={onControlChange} multiple={multiple} />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default FileUploadControl;